import { render, staticRenderFns } from "./SoundPound.vue?vue&type=template&id=3c1d1028&"
import script from "./SoundPound.vue?vue&type=script&lang=js&"
export * from "./SoundPound.vue?vue&type=script&lang=js&"
import style0 from "./SoundPound.vue?vue&type=style&index=0&id=3c1d1028&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports